export default __webpack_public_path__ + "static/media/en-vivo.f09e4a9c.svg";